import request from '@/utils/request'
import qs from 'qs'

export const getBugTrend = (params) => {
    return new request({
        url: './vulnerability/vulnerabilityInfos/countVulTrend',
        method: 'get',
        params:params,
        headers:{
            type:'statis',
        }
    });
}
export const getBugYear = (params) => {
    return new request({
        url: './vulnerability/vulnerabilityInfos/countVulByYear',
        method: 'get',
        params:params,
        headers:{
            type:'statis',
        }
    });
}
export const getBugType = (params) => {
    return new request({
        url: './vulnerability/vulnerabilityInfos/countTypeByDate',
        method: 'get',
        params:params,
        headers:{
            type:'statis',
        }
    });
}
